<template>
<div class="main">
  <header id="header" :style="`background-color: ${library.color};`">
    <div class="container">
      <h2>{{ library.name }}</h2>
      <a-input-search
      :placeholder="`${$t('browse')}...`"
      :loading="searchLoading"
      size="large"
      class="search"
      @search="onSearch($event)"
      @input="onSearch($event.target.value)"
    />
    </div>
  </header>
  <div class="container">
    <a-row :gutter="[27, 27]" justify="space-around">
      <a-col :span="12" v-for="(item, index) in documentTypes" :key="`documentTypes-${index}`">
        <a-card :title="item.document.typeAlias" :extra="`${documents[index].length} ${$t('documents')}`" class="card-wrapper" :bordered="false" v-if="documents[index].length">
          <a-row type="flex" justify="start" v-for="(document, docindex) in documents[index]" :key="`documents-${docindex}`">
            <a-col :span="24">
              <router-link :to="`/bibliotecapublica/${library.slug}/page/${document._id}`">
                <a-button type="link" class="link">
                  {{ document.documentName }}
                </a-button>
              </router-link>
            </a-col>
          </a-row>
          </a-card>
      </a-col>
    </a-row>
  </div>
</div>
</template>

<script>
import commonsApi from '@/api/commons'
import _ from 'lodash'
export default {
  data () {
    return {
      library: {},
      documentTypes: {},
      documents: {},
      initialDocuments: {},
      searchLoading: false
    }
  },
  methods: {
    onSearch (text) {
      let textToSearch = text.toLowerCase()
      this.searchLoading = true
      // Resetea documents con los valores iniciales
      this.documents = this.initialDocuments
      // Si hay texto filtra por documentName
      if (textToSearch !== '') {
        let documents = _.cloneDeep(this.initialDocuments)
        for (const [i, documentTypes] of this.documents.entries()) {
          documents[i] = documentTypes.filter(el => el.documentName.toLowerCase().includes(textToSearch))
        }
        this.documents = documents
        this.searchLoading = false
      } else {
        // Si no hay texto vuelve al valor inicial
        this.documents = this.initialDocuments
        this.searchLoading = false
      }
    }
  },
  async created () {
    try {
      const res = await commonsApi.axiosGetWrapper(`/documentlibrary/getlibrary/${this.$route.params.slug}`)
      this.documentTypes = res.data.documentTypes
      this.documents = res.data.documents
      this.initialDocuments = res.data.documents
      this.library = res.data.library
    } catch (error) {
      console.log('error:', error)
    }
  }
}
</script>

<style scoped>
.main{
  background: #f3f5f7;
  height: 100%;
  min-height: 100vh;
}
#header{
    background: white;
    padding: 25px 0;
    margin-bottom: 7px;
    flex: none;
    position: relative;
    z-index: 10;
    background-size: cover;
    box-shadow: 0 1px 4px 0 rgb(0 0 0 / 20%);
    background-position: 50%;
}
.container{
  padding: 27px;
}
.card-wrapper{
  border-radius: 4px;
  box-shadow: 0 5px 10px rgb(0 0 0 / 5%);
}
.link{
  padding:0
}
.search{
  box-shadow: 0 5px 20px rgb(0 0 0 / 5%);
  margin: 10px 0px;
}
</style>
